module.exports = __webpack_public_path__ + "img/circle-star.32d60320.svg";